import BillingPlans from './BillingPlans';

export default {
  ReactComponent: BillingPlans,
  bindings: {
    callbackAfterUpgrade: '&',
    subscriptionLevel: '<',
    isOldPremium: '<',
    orgSettings: '<',
    startTrial: '&',
    goToPurchase: '<',
  },
};
